enum ActionTypes {
  IS_PROCESSING = "app/broadcastRecording/IS_PROCESSING",
  RESET = "app/broadcastRecording/RESET",
  START_RECORDING = "app/broadcastRecording/START_RECORDING",
  STOP_RECORDING = "app/broadcastRecording/STOP_RECORDING",
  UPDATE_ACCOUNT_USAGE = "app/broadcastRecording/UPDATE_ACCOUNT_USAGE",
}

export type IBroadcastRecordingState = {
  archiveId: null | string;
  isLimitReached: boolean;
  usedLimit: number;
  maxLimit: number;
  isProcessing: boolean;
} & (
  | {
      isRecording: true;
      recordingStartedAt: number;
    }
  | {
      isRecording: false;
      recordingStartedAt: null;
    }
);

export const initialState: IBroadcastRecordingState = {
  isRecording: false,
  archiveId: null,
  recordingStartedAt: null,
  isLimitReached: false,
  usedLimit: 0,
  maxLimit: 0,
  isProcessing: false,
};

export default ActionTypes;
